import React, { useState, createContext, ReactNode } from "react";
import en from "../locale/en.json";
import he from "../locale/he.json";

// Available languages
export const language_options = [
  { id: "he", text: "Hebrew" },
  { id: "en", text: "English" },
];

type Language = {
  id: string;
  text: string;
};

type Dictionary = {
  [key: string]: string;
};

export interface LanguageProviderContextType {
  language: Language;
  setLanguage: (selected_language: Language) => void;
  dictionary: Dictionary;
  getTranslation: (text_id: string) => string;
}

export const LanguageContext = createContext<LanguageProviderContextType>({
  language: language_options[0],
  setLanguage: () => {},
  dictionary: he,
  getTranslation: (text_id: string) => text_id,
});

const LanguageProvider: React.FC<{ children: ReactNode }> = (props) => {
  const [language, setLanguage] = useState<Language>(language_options[0]);
  const [dictionary, setDictionary] = useState<Dictionary>(he); // Set default dictionary

  const provider = {
    language,
    setLanguage: (selected_language: Language) => {
      setLanguage(selected_language);
      setDictionary(selected_language.id === "en" ? en : he); // Switch dictionary based on language
    },
    dictionary,
    getTranslation: (text_id: string) => {
      return dictionary[text_id] ? dictionary[text_id] : text_id;
    },
  };

  return <LanguageContext.Provider value={provider}>{props.children}</LanguageContext.Provider>;
};

export default LanguageProvider;
